import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Protocol17025Cat_Interface } from 'src/app/Interface/Protocol17025/Protocol17025Cat_Interface';

@Component({
  selector: 'app-Protocol17025Cat_Co_Check',
  templateUrl: './Protocol17025Cat_Co_Check.component.html',
  styleUrls: ['./Protocol17025Cat_Co_Check.component.scss']
})
export class Protocol17025Cat_Co_CheckComponent implements OnInit {

  @Input() inner_17025_Cat: Array<Protocol17025Cat_Interface> = []
  @Output() On_Change_Action = new EventEmitter<Protocol17025Cat_Interface>();


  constructor() { }

  ngOnInit() {
  }

  Change_Visible(item: Protocol17025Cat_Interface) {
    this.On_Change_Action.emit(item);
  }


}
